import {
  ContentContainer,
} from "@/pages/layouts/main-content";
import { RotateCw } from "lucide-react";
import { useNotes } from "@/providers/note-provider";
import { NoteList } from "@/pages/subs/notes/note-list";
import { NoteContent } from "@/pages/subs/notes/note-content";
import { NoteMenu } from "@/pages/subs/notes/note-menu";

export function MainNotes({ hidden }: { hidden?: boolean }) {
  const { activeNote, selectNote, loading, syncNow } = useNotes();

  const handleCloseNote = () => {
    selectNote(null);
    syncNow();
  };

  return (
    <ContentContainer hidden={hidden}>
      <div className="flex flex-col w-full h-full">
        <div className="w-full flex-none border-b">
          <NoteMenu />
        </div>
        <div className="flex-1 overflow-auto">
          <NoteList />
        </div>
      </div>
      {activeNote && (
        <NoteContent note={activeNote} onClose={handleCloseNote} />
      )}
      {loading && (
        <div className="absolute inset-0 bg-background/80 backdrop-blur-sm z-50 flex items-center justify-center p-2">
          <RotateCw className="h-6 w-6 animate-spin" />
        </div>
      )}
    </ContentContainer>
  );
}
